/**
 * Whether a link in an answer can be followed as written. Only an absolute address can: a relative
 * one resolves against whatever page the assistant happens to be open on, so the same answer goes
 * somewhere different from Reports than from Leads, and never where it was meant to. The model has
 * written exactly that — `…/extension?profileId=21480`, opened as /reports/…/extension — when it
 * built a link itself instead of copying the one a tool returned.
 *
 * A link that fails this is shown as its words and nothing else, not repaired: there is no way to
 * know from here which page it was meant to be.
 */
export const isFollowableLink = (href) => typeof href === "string" && /^(https?:\/\/|mailto:|tel:)/i.test(href.trim());
